module.exports = __webpack_public_path__ + "img/area-comum-06.c0cd54b2.png";